import { notificationInstance } from '@/shared/api/api-instances/notification/api-instance';
import type { NotificationSubscriptionReceiver } from '../model/subscription-receiver';
import { type AxiosRequestConfig } from 'axios';

export class NotificationSubscriptionsReceiversApi {
  static getNotificationSubscriptionReceivers(options?: AxiosRequestConfig) {
    return notificationInstance.get<NotificationSubscriptionReceiver[]>(
      `/receivers`,
      options,
    );
  }

  static createNotificationSubscriptionReceiver(
    payload: NotificationSubscriptionReceiver,
    options?: AxiosRequestConfig,
  ) {
    return notificationInstance.post<NotificationSubscriptionReceiver>(
      `/receiver`,
      payload,
      options,
    );
  }

  static updateNotificationSubscriptionReceiver(
    id: string,
    payload: NotificationSubscriptionReceiver,
    options?: AxiosRequestConfig,
  ) {
    return notificationInstance.put<NotificationSubscriptionReceiver>(
      `/receiver/${id}`,
      payload,
      options,
    );
  }
}